import { EWidgetMode } from '../../../types/redux/layout';
import { formatMoney } from '../../../utils/string';

interface IParams {
  mode: EWidgetMode;
  amount: number;
  min: number;
  max: number | undefined;
}

export const validatePaymentAmount = (params: IParams): string | null => {
  const { mode, amount, min, max } = params;

  if (mode !== EWidgetMode.Deposit) {
    return null;
  }

  if (typeof amount !== 'number') {
    return 'Укажите сумму';
  }

  if (amount < min) {
    return `Минимальный платёж — ${formatMoney(min)}`;
  }

  if (max && amount > max) {
    return `Максимальный платёж — ${formatMoney(max)}`;
  }

  return null;
};
